import logoSkill from '../../themes/assets/skill.png';
import logoCps from '../../themes/assets/logo-cps.jpg';
import logoiClouds from '../../themes/assets/logo-iclouds.svg';
import bootcampRocketseat from '../../themes/assets/bootcampRocketseat.png';

export default {
  jobs: [
    // {
    //   id: 1,
    //   local: 'Datametrica',
    //   img: logoDatametrica,
    // },
    {
      id: 2,
      local: 'iClouds',
      img: logoiClouds,
    },
    {
      id: 3,
      local: 'SkillIdiomas',
      img: logoSkill,
    },
  ],
  studies: [
    {
      id: 1,
      local: 'Fatec Itapetininga',
      img: logoCps,
    },
    {
      id: 2,
      local: 'BootcampRocketseat',
      img: bootcampRocketseat,
    },
    // {
    //   id: 3,
    //   local: 'Origamid',
    //   img: origamidLogo,
    // },
  ],
};
